import React, { useEffect, useContext, useState } from "react";
import { StoreContext } from "@Context/StoreContext";
import { Search, Results, ExtendedSearch } from "@Pages/";
import { getStorageValue } from "@Lib/storage";

const EntryPoint = ({ module }) => {
  const { state, actions } = useContext(StoreContext);
  const [loaded, setLoaded] = useState({
    places: false,
    suggestions: false,
    input: false,
    details: false,
    allLoaded: false,
  });

  const extendedSearchRoot = document.getElementById("appExtendedSearch");
  const placesFromStorage = getStorageValue("TNLZSPlaces", "local");
  const filterDataFromStorage = getStorageValue("TNLZSSuggestions");
  const searchInput = getStorageValue("TNLZSInput");
  const allDetails = getStorageValue("TNLZSDetails");

  useEffect(() => {
    if (!loaded.allLoaded) {
      checkWhatIsLoaded();
    }

    console.log("state", loaded);

    /*
    if (!state.search.suggestions.Places && !state.search.suggestionsLoaded) {
    } else if (!state.search.suggestionsLoaded) {
      state.search.suggestions.Companies
        ? actions.setSuggestionsLoaded()
        : null;
    }

    if (state.search.suggestionsLoaded && !state.search.searchInput) {
    }
    if (state.search.suggestionsLoaded && !state.search.detailsLoaded) {
    }
    if (
      state.search.suggestionsLoaded &&
      state.search.suggestions &&
      state.search.searchInput
    ) {
      setLoaded({
        ...loaded,
        loading: false,
      });
    }*/
  }, [loaded]);

  function checkWhatIsLoaded() {
    if (!loaded.places) {
      placesFromStorage
        ? actions.setPlaces(JSON.parse(placesFromStorage))
        : actions.getPlaces("places.json");
      setLoaded((prevLoaded) => ({
        ...prevLoaded,
        places: true,
      }));
    }
    if (!loaded.suggestions) {
      filterDataFromStorage
        ? actions.setSuggestionsData(JSON.parse(filterDataFromStorage))
        : actions.getSuggestionsData("GetInfoForFiltering.aspx");
      setLoaded((prevLoaded) => ({
        ...prevLoaded,
        suggestions: true,
      }));
    }
    if (!loaded.input) {
      searchInput && module !== "search"
        ? actions.setSearchInputViaStorage(JSON.parse(searchInput)[0])
        : actions.setSearchInputViaStorage({});
      setLoaded((prevLoaded) => ({
        ...prevLoaded,
        input: true,
      }));
    }
    if (!loaded.details) {
      allDetails
        ? actions.setDetails(JSON.parse(allDetails))
        : actions.getDetails("GetDetails.aspx");
      setLoaded((prevLoaded) => ({
        ...prevLoaded,
        details: true,
      }));
    }
    if (loaded.places && loaded.suggestions && loaded.input && loaded.details) {
      setLoaded((prevLoaded) => ({
        ...prevLoaded,
        allLoaded: true,
      }));
    }
  }

  if (loaded.allLoaded) {
    switch (module) {
      case "search":
        return (
          <section className="member-search">
            <Search />
          </section>
        );
      case "results":
        if (state.search.detailsLoaded) {
          return (
            <>
              <section className="member-search">
                <Results />
              </section>
              {extendedSearchRoot && <ExtendedSearch />}
            </>
          );
        }
        break;
    }
  }

  return (
    <section className="member-search">
      <section className="search-box">
        <p>Bezig met laden...</p>
      </section>
    </section>
  );
};

export { EntryPoint };
